import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Lock } from 'lucide-react';

const AdminLogin = () => {
  const { login } = useAuth();

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    // Must redirect to /admin/callback first to process the session_id
    login('/admin/callback');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#ECEC75] via-[#e6e67c] to-[#ECEC75] flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        {/* Logo */}
        <div className="text-center mb-8">
          <img
            src="https://customer-assets.emergentagent.com/job_cosmos-tacos/artifacts/m0583hsq_Le%20Cosmos%20Logo.jpg"
            alt="Le Cosmos"
            className="w-32 h-32 mx-auto rounded-full shadow-2xl object-cover mb-4"
          />
          <h1 className="text-4xl font-bold text-black mb-2" style={{ fontFamily: 'Crimson Text, serif' }}>
            Espace Administrateur
          </h1>
          <p className="text-black/70">Le Cosmos Saint-Étienne</p>
        </div>

        {/* Login Card */}
        <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-2xl p-8">
          <div className="flex items-center justify-center mb-6">
            <div className="bg-black p-4 rounded-full">
              <Lock size={32} className="text-[#D4AF37]" />
            </div>
          </div>

          <h2 className="text-2xl font-bold text-center text-black mb-4">
            Connexion Sécurisée
          </h2>

          <p className="text-center text-black/70 mb-8">
            Réservé au propriétaire du restaurant uniquement.
          </p>

          <button
            onClick={handleLogin}
            className="w-full bg-black text-white px-8 py-4 rounded-xl font-semibold hover:bg-black/90 transition-all duration-200 hover:transform hover:-translate-y-1 hover:shadow-xl flex items-center justify-center space-x-3"
          >
            <svg className="w-6 h-6" viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
              />
              <path
                fill="currentColor"
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              />
              <path
                fill="currentColor"
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
              />
              <path
                fill="currentColor"
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
              />
            </svg>
            <span>Se connecter avec Google</span>
          </button>

          <div className="mt-6 text-center">
            <p className="text-sm text-black/60">
              🔒 Connexion sécurisée via Emergent Auth
            </p>
          </div>
        </div>

        {/* Info Box */}
        <div className="mt-6 bg-black/80 backdrop-blur-sm rounded-xl p-6 text-white">
          <h3 className="font-bold mb-2">Accès Restreint</h3>
          <p className="text-sm text-white/80">
            Seul le compte Google du propriétaire peut accéder au dashboard administrateur.
            Contactez le support si vous rencontrez des problèmes d'accès.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
